import axios from "axios";
import { config } from "services/globalvariables/globalvariables";
import { notifyAddTocart } from "../components/MyProfile";
//
const BASE_URL = `${process.env.REACT_APP_HOST}`;
//
// ------------------------------------------
// -------API Service for State List------------
// ------------------------------------------
export const getStateteList = async () => {
  const response = await fetch(
    `${BASE_URL}/partner/v1/view_states/?key=qwerty`,
    config
  );

  if (!response.ok)
    throw new Error(`Err:${response.statusText} | failed to fetch State list!`);
  const data = await response.json();

  return data?.data;
};
//
// ------------------------------------------
// -------API Service for State List------------
// ------------------------------------------
export const getDistrictList = async (stateId) => {
  const response = await fetch(
    `${BASE_URL}partner/v1/view_districts?state_id=${stateId}&key=qwerty`,
    config
  );

  if (!response.ok)
    throw new Error(`Err:${response.statusText} | failed to fetch State list!`);
  const data = await response.json();

  return data?.data;
};

export const SubmitEnquery = async (values) => {
  return axios
    .post(
      `${process.env.REACT_APP_HOST}/showroom/api/v1/product_inquiry`,
      values,
      config
    )
    .then(function (response) {
      if (response.data.status === 208) {
        notifyAddTocart("Your previous enquiry is already in proces");
      }
      if (response.data.status === 200) {
        notifyAddTocart(
          "Thank you, your enquiry has been submitted successfully"
        );
      }
    })
    .catch(function (error) {
      console.log(error);
    });
};
